import gql from 'graphql-tag';

export const createEquipmentMutation = gql(/* GraphQL */ `
  mutation createEquipmentMutation($createEquipment: EquipmentInput) {
    createEquipment(equipment: $createEquipment) {
      id
    }
  }
`);
